import { Injectable } from '@angular/core';
import { AnnotationOptions, LineAnnotationOptions } from 'chartjs-plugin-annotation';
import { ThemeService } from '../../_core/services/theme.service';
import { Game, GameFormat } from '../../_shared/models/game.model';
import { Point } from '../../_shared/models/point.model';

@Injectable({
  providedIn: 'root'
})
export class MomentumChartService {
  point = {
    0: '0',
    1: '15',
    2: '30',
    3: '40',
    4: 'A'
  };

  constructor(
    private themeService: ThemeService
  ) { }

  getPointScore(side: number, point: Point, game: Game) {
    if (game.gameFormat === GameFormat.TIEBREAK) {
        if (side === 1) return point.side1Score;
        else return point.side2Score;
    } else {
        if (side === 1) return this.point[point.side1Score];
        else return this.point[point.side2Score];
    }
  }

  getAnnotationObj(type: string, yAxisValue, winningSide: number, colors): AnnotationOptions {
    let borderWidth = 1;
    if (type === 'set') borderWidth = 2;

    return {
      type: 'line',
      scaleID: 'y',
      value: yAxisValue,
      borderColor: colors.gridColor,
      borderWidth: 2,
      label: {
        display: true,
        content: type.toUpperCase(),
        backgroundColor: winningSide === 1 ? colors.side1Color : colors.side2Color,
        borderColor: this.themeService.isDarkMode ? '#222428' : '#f4f5f8',
        font: {
          size: 11,
          family: 'Arial',
          style: 'normal',
          weight: 'bold',
          lineHeight: 0.75
        },
        borderWidth: 3,
        position: winningSide === 1 ? 'start' : 'end'
      }
    }
  }
}
